import Footer from '@Components/footer'
import { PropsWithChildren } from 'react'
import NavBar from '@Components/navBar'
import { NavbarResponse } from '../../apis/navbar'
import { FooterResponse } from '../../apis/footer'

interface LayoutProps extends PropsWithChildren {
  navbar?: NavbarResponse
  footer?: FooterResponse
  className?: string
}

const Layout = ({
  children,
  navbar,
  footer,
  className = 'bg-neutral-level-1-default',
}: LayoutProps) => {
  return (
    <div className='flex min-h-screen min-w-[22.5rem] flex-col bg-neutral-level-2-default'>
      <NavBar navbar={navbar} />
      <div className={`flex flex-col ${className} flex-1`}>{children}</div>
      <Footer footer={footer} />
    </div>
  )
}

export default Layout
